// extracted by mini-css-extract-plugin
module.exports = {"candle-green":"CandleChart_candle-green__LPQF8","candle-red":"CandleChart_candle-red__3Lj49"};